import React, { useState } from 'react';
import { Button, SpaceBetween, StatusIndicator, Box, Popover } from '@amzn/awsui-components-console';
import copy from 'copy-to-clipboard';

/**
 * get hidden token
 * @return {Object} get hidden token in popover
 */
export function getHiddenToken(token) {
    const hiddenToken = '******' + token.substring(token.length - 5);
    return (
        <span>
            <SpaceBetween direction="horizontal" size="xxs">
                <Box color="inherit" display="inline-block">
                    <Popover
                        size="small"
                        position="top"
                        triggerType="custom"
                        dismissButton={false}
                        content={<StatusIndicator type="success">copied</StatusIndicator>}
                    >
                        <Button variant="inline-icon" iconName="copy" onClick={() => copy(token)} />
                    </Popover>
                </Box>
                <Box color="inherit"> {hiddenToken} </Box>
            </SpaceBetween>
        </span>
    );
}

/**
 * get time to live from seconds to a date
 * @return {String} date string
 */
export function getTTLInDate(ttl) {
    const date = new Date(ttl * 1000);
    return date.toUTCString();
}
